import moment from 'moment';
import request from '../../../util/SuperagentUtils';
import { DateFormats } from '../../constants/securspace-constants';
import { buyerInterchangesReportEndpoints, buyerInventoryCorrectionReport } from '../../../requests/api-endpoints';

const getInterChangesUrlParams = (requestParams, isPageable) => {

  const { page, size, startDate, endDate, locationId, locationName, bookingNumber, sortBy, supplierName, equipmentType, equipmentNumber, driverName, driverNameExact, sortDir } = requestParams;

  const params = isPageable ? new URLSearchParams([["page", page || 0], ["size", size || 10]]) : new URLSearchParams();

  if (startDate) {
    params.append("startDate", moment(startDate).format(DateFormats.DAY));
  }
  if (endDate) {
    params.append("endDate", moment(endDate).format(DateFormats.DAY));
  }
  if (locationId) {
    params.append("locationId", locationId)
  }
  if (locationName && !isPageable) {
    params.append("locationName", locationName)
  }
  if (bookingNumber) {
    params.append("bookingNumber", bookingNumber)
  }
  if (sortBy && sortBy !== 'none') {
    params.append("sortBy", sortBy)
  }
  if (supplierName) {
    params.append("supplierName", supplierName?.trim())
  }
  if (equipmentType && equipmentType !== 'All') {
    params.append("equipmentType", equipmentType)
  }
  if (equipmentNumber) {
    params.append("equipmentNumber", equipmentNumber)
  }

  if (driverName) {
    params.append("driverName", driverName);
    params.append("driverNameExact", driverNameExact || 'false');
  }

  if (sortDir) {
    params.append("sortDir", sortDir)
  }

  return params;
}

export const getBuyerInterChanges = (searchParams, onSuccess, onFail ) => {

  const result = request.get(`${buyerInterchangesReportEndpoints.search}?${getInterChangesUrlParams(searchParams, true)}`);

  if (onSuccess && onFail) {
    result
      .then(onSuccess)
      .catch(onFail)
  } else {
    return result
  }
}

export const getBuyerInterChangeReportUrl = (searchParams) => {
  return `${buyerInterchangesReportEndpoints.report}?${getInterChangesUrlParams(searchParams, false)}`;
}

export const getBuyerInterChangeSummaryReportUrl = (searchParams) => {
  return `${buyerInterchangesReportEndpoints.summaryReport}?${getInterChangesUrlParams(searchParams, false)}`;
}

export const getBuyerInventoryCorrectionReviewReportUrl = (searchParams) => {
  return `${buyerInventoryCorrectionReport.review}?${getInterChangesUrlParams(searchParams, true)}`;
}
